module.exports = __webpack_public_path__ + "img/dox-lost-loop.fe378529.gif";